import { render, staticRenderFns } from "./UiMaskedInput.vue?vue&type=template&id=187994c0&"
import script from "./UiMaskedInput.vue?vue&type=script&lang=js&"
export * from "./UiMaskedInput.vue?vue&type=script&lang=js&"
import style0 from "./UiMaskedInput.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/UiMaskedInput.vue
// module id = 1097
// module chunks = 0